import { z } from 'zod';
import { capitalize } from '../../utils/capitalize.js';
import { optionalFormTrimmedEmail, optionalFormTrimmedString } from '../zod-helpers/index.js';
import { CONTACT_CONSTRAINTS } from './constraints.js';
import { CONTACT_PREFERRED_METHODS } from './preferred-method/index.js';
// Create: blank/null collapses to undefined so toCreateContactInput's ?? null defaults it to null.
const preferredMethodFormSchema = z
    .enum([...CONTACT_PREFERRED_METHODS, ''], 'Invalid preferred contact method.')
    .optional()
    .nullable()
    .transform((value) => (value === '' || value == null ? undefined : value));
export const contactFormSchema = z.object({
    contactName: z
        .string()
        .trim()
        .min(1, `${capitalize(CONTACT_CONSTRAINTS.contactName.label.toLowerCase())} is required.`)
        .max(CONTACT_CONSTRAINTS.contactName.maxLength),
    title: optionalFormTrimmedString(CONTACT_CONSTRAINTS.title.maxLength),
    email: optionalFormTrimmedEmail(CONTACT_CONSTRAINTS.email.maxLength, `Invalid ${CONTACT_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: optionalFormTrimmedString(CONTACT_CONSTRAINTS.phone.maxLength),
    preference: preferredMethodFormSchema,
    defaultFlag: z.boolean().optional().nullable(),
});
//# sourceMappingURL=create-form.js.map